<template>
  <Search />
</template>

<script>
import Search from '@/components/Search';
export default {
  components: {
    Search
  },
  nuxtI18n: {
    paths: {
      en: '/merch/editable-online/:search'
    }
  }
};
</script>

<style></style>
